/**
 * Customer Redirect Handler
 * Post-login redirects based on company metafields:
 * - Priority 1: custom.ski_customer (redirects to settings.ski_customer_page)
 * - Priority 2: custom.index_page_redirect (page reference metafield)
 */

class CustomerRedirectHandler {
  constructor() {
    this.settings = window.customerRedirectSettings || {};
    this.enabled = this.settings.enabled !== false;

    if (!this.enabled) {
      return;
    }

    this.init();
  }

  init() {
    // This is now a fallback only - main redirect happens in <head>
    // Only run if somehow the head redirect didn't work
    if (this.isHomepage() && !this.isOnRedirectTargetPage() && this.isLoggedIn()) {
      this.handleHomepageRedirect();
    }
  }

  getRedirectUrl() {
    // Priority 1: Ski customer redirect
    const customer = window.theme?.customer;
    const companySkiValue = customer?.companySkiMetafield;
    if ((companySkiValue === true || companySkiValue === 'true') && this.settings.skiPageUrl) {
      return this.settings.skiPageUrl;
    }

    // Priority 2: Company index page redirect metafield
    if (customer?.companyIndexPageRedirect) {
      return customer.companyIndexPageRedirect;
    }

    // Also check settings for the URL (in case customer object doesn't have it)
    if (this.settings.indexPageRedirectUrl) {
      return this.settings.indexPageRedirectUrl;
    }

    return null;
  }

  wasServerSideRedirectHandled() {
    // Check if server-side redirect logic should have handled this
    return this.getRedirectUrl() !== null;
  }

  isHomepage() {
    return window.location.pathname === '/' ||
           window.location.pathname === '' ||
           window.location.pathname === '/pages/frontpage';
  }

  isOnRedirectTargetPage() {
    const redirectUrl = this.getRedirectUrl();
    if (!redirectUrl) {
      return false;
    }

    try {
      const redirectPath = new URL(redirectUrl, window.location.origin).pathname;
      const currentPath = window.location.pathname;
      return currentPath === redirectPath;
    } catch (error) {
      return false;
    }
  }

  isLoggedIn() {
    // Check if customer data is available (indicating logged in state)
    return !!window.theme?.customer?.id;
  }

  handleHomepageRedirect() {
    try {
      const redirectUrl = this.getRedirectUrl();
      if (!redirectUrl) {
        return;
      }

      // Check if we're not already on the redirect target page
      const currentPath = window.location.pathname;
      const redirectPath = new URL(redirectUrl, window.location.origin).pathname;

      if (currentPath !== redirectPath) {
        window.location.replace(redirectUrl);
      }
    } catch (error) {
      // Silent error handling for production
    }
  }

  getCustomerData() {
    // Use customer data from theme.liquid (server-side)
    if (window.theme?.customer) {
      return window.theme.customer;
    }

    return null;
  }
}

// Initialize fallback handler (main redirect happens in <head>)
(function() {
  const settings = window.customerRedirectSettings;
  if (!settings?.enabled) return;

  const isHomepage = window.location.pathname === '/' ||
                     window.location.pathname === '' ||
                     window.location.pathname === '/pages/frontpage';

  // Quick check - don't run if already on a redirect target page
  const customer = window.theme?.customer;
  const companySkiValue = customer?.companySkiMetafield;
  const skiPageUrl = (companySkiValue === true || companySkiValue === 'true') ? settings.skiPageUrl : null;
  const indexPageRedirectUrl = customer?.companyIndexPageRedirect || settings.indexPageRedirectUrl;
  const redirectUrl = skiPageUrl || indexPageRedirectUrl;

  let isOnRedirectPage = false;
  if (redirectUrl) {
    try {
      isOnRedirectPage = window.location.pathname === new URL(redirectUrl, window.location.origin).pathname;
    } catch (e) {}
  }

  // Only initialize as fallback on homepage
  if (isHomepage && !isOnRedirectPage) {
    new CustomerRedirectHandler();
  }
})();

// Export for potential use by other scripts
window.CustomerRedirectHandler = CustomerRedirectHandler;
